import store from "../../../store";
import {v4 as uuidv4} from "uuid";

import {convertToSvg} from "../svg/convertToSvg";
import cleanSvg from "../svg/cleanSvg";
import {makePngFromSvg} from "../svg/makePngFromSvg";
import cacheImages from "../svg/cacheImages";
import getCoverSize from "./util/getCoverSize";
import svgToPng from "../svg/svgToPng";
import applyEffects from "./effects/applyEffects";
import initialEffect from "./effects/initialEffect";
import svgOutline from "./util/svgOutline";
import getBoundingBoxByAngle from "../svg/getBoundingBoxByAngle";
//import svgOutline from "./util/svgOutline";


const addNewUploadedElement = async (file, sectionId, oldId = null, custom = {}) => {
    return new Promise(async (resolve, reject) => {
        
        /* let time = new Date().getTime()
         const getTime = () => {
             console.log("time", new Date().getTime() - time)
             time = new Date().getTime()
         }*/
        
        
        const id = oldId || uuidv4()
        const increaseQuality = 20
        let currentElement = null
        let customValues = null
        
        
        if (oldId) {
            currentElement = store.elements.find(e => e.elementId === oldId)
            customValues = {
                ...currentElement?.custom,
                ...custom
            }
        } else {
            //getTime()
            
            const convertedPngObject = await svgToPng(file)
            const convertedPng = convertedPngObject.file
            customValues = await initialEffect({rawFile: convertedPng, id: id})
            
            //getTime()
            
        }
        
        
        const convertedImage = await applyEffects({id, customValues})
        
        
        const section = store.sections.find(e => e.section_id === sectionId)
        //const imageBoxWidth = currentElement?.width || section.width
        
        const rawImage = customValues?.rawImage
        //const convertedImage = URL.createObjectURL(convertedImageData)
        
        const svgCode = await convertToSvg(convertedImage)
        const changedSvg = await cleanSvg(svgCode, section.width * increaseQuality) //Clean svg and change size
        
        const imgData = await makePngFromSvg(changedSvg.svg)
        
        const imgSize = getCoverSize(section, imgData, 1)
        
        const {effect, ...customData} = customValues
        
        await cacheImages(imgData.blob, id)
        
        const snapping = await getBoundingBoxByAngle({
            width: imgSize.width,
            height: imgSize.height,
            angle: 0,
            outline: changedSvg.outline,
            offset_x: section.offset_x,
            offset_y: section.offset_Y,
            sectionWidth: section.width,
            sectionHeight: section.height,
            section_offset_y: section.offset_Y,
            lockMove: true
        })
        
        const element = {
            sectionId: sectionId,
            elementId: id,
            index: currentElement?.index || store.elements.length,
            visible: true,
            type: "custom",
            image: imgData.imgUrl,
            custom: {
                rawImage: rawImage,
                width: imgData.width,
                height: imgData.height,
                optimalValue: customValues?.optimalValue,
                contrast: customValues?.contrast,
                effect: {
                    invert: customData?.effect?.invert || false,
                    ...effect
                },
                ...customData
            },
            outline: changedSvg.outline,
            snapping: snapping,
            needToCheck: true,
            width: imgSize.width,//imageBoxWidth,
            height: imgSize.height,//(imgData.height * imageBoxWidth) / imgData.width,
            offset_x: currentElement?.offset_x || section.offset_x,
            offset_y: currentElement?.offset_y || section.offset_Y,
            radialAngle: currentElement?.radial_angle || section.radial_angle,
            angle: currentElement?.angle || section.angle || 0,
            insideData: {
                intersect: true, // If the element is intersecting the section
                isInside: true, // If the element is intersecting the section
                points: [true, true, true, true] // Points of the element that are inside the section
            },
            lockMove : true,
        }
        
        if (oldId) {
            const index = store.elements.findIndex(e => e.elementId === oldId)
            URL.revokeObjectURL(store.elements[index].image)
            store.elements[index] = element
            store.editElement = element
        } else {
            store.elements.push(element)
        }
        
        const threeViewerSection = window.threeViewer.scene.children.find(e => e.userData.id === sectionId && e.type === "section");
        
        threeViewerSection.update()
        await threeViewerSection.helper.show(element)
        
        
        store.selectedElementId = id
        store.ui.addModalVisibility = false
        store.ui.zoom = sectionId
        
        //const decal = await generateElement(element, oldId)
        resolve(element);
        
        
    })
}
export default addNewUploadedElement;